/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				$(document).on("breakpoint:changed", function(evt, newBreakpointName){

					var testimonialsSlideshowRatios = {
						xxs:"43:48",
						xs: "10:7",
						sm: "27:16",
						ms: "125:58",
						md: "77:26",
						lg: "93:26",
						xl: "6:1"
					};

					var newSlideshowRatio = (testimonialsSlideshowRatios.hasOwnProperty(newBreakpointName)) ? testimonialsSlideshowRatios[newBreakpointName] : "";

					if( $( ".franchisee-testimonials-slideshow" ).length > 0 ) {
						if($(".franchisee-testimonials-slideshow").attr("data-uk-slideshow").indexOf(newSlideshowRatio) === -1){
							$(".franchisee-testimonials-slideshow").attr("data-uk-slideshow", "ratio: " + newSlideshowRatio);
						}
					}

				});

				
				/**
				 * Desktop Hamburger Menu for overview v2 template
				 */
				$( ".home-v2-toggle" ).on( 'click', function() {
					$( '.home-v2-toggle' ).toggleClass( "uk-open" );
					$( "body" ).toggleClass( "national-nav-open" );

					if( $( '.home-v2-toggle' ).hasClass( "uk-open" ) ) {
						$( ".header-top-banner-wrap a[data-open-state-href]" ).each( function() {
							$( '.home-v2-toggle' )
								.data( "orig-state-href", $( '.home-v2-toggle' ).attr( "href" ) )
								.attr( "href", $( '.home-v2-toggle' ).data( "open-state-href" ) );
						} );
					}
					
					else {
						$( ".header-top-banner-wrap a[data-open-state-href]" ).each( function() {
							$( '.home-v2-toggle' )
								.attr( "href", $( '.home-v2-toggle' ).data( "orig-state-href" ) )
								.removeAttr( "data-orig-state-href" );
						} );
					}
				} );

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		'home': {
			init: function(){

				// $(document).on("breakpoint:changed", function(evt, newBreakpointName){

				// 	var testimonialsSlideshowRatios = {
				// 		xxs:"43:48",
				// 		xs: "10:7",
				// 		sm: "27:16",
				// 		ms: "125:58",
				// 		md: "77:26",
				// 		lg: "93:26",
				// 		xl: "6:1"
				// 	};

				// 	var newSlideshowRatio = (testimonialsSlideshowRatios.hasOwnProperty(newBreakpointName)) ? testimonialsSlideshowRatios[newBreakpointName] : "";

				// 	if($(".franchisee-testimonials-slideshow").attr("data-uk-slideshow").indexOf(newSlideshowRatio) === -1){
				// 		$(".franchisee-testimonials-slideshow").attr("data-uk-slideshow", "ratio: " + newSlideshowRatio);
				// 	}

				// });

				
				// /**
				//  * Desktop Hamburger Menu for overview v2 template
				//  */
				// $( ".home-v2-toggle" ).on( 'click', function() {
				// 	$( '.home-v2-toggle' ).toggleClass( "uk-open" );
				// 	$( "body" ).toggleClass( "national-nav-open" );

				// 	if( $( '.home-v2-toggle' ).hasClass( "uk-open" ) ) {
				// 		$( ".header-top-banner-wrap a[data-open-state-href]" ).each( function() {
				// 			$( '.home-v2-toggle' )
				// 				.data( "orig-state-href", $( '.home-v2-toggle' ).attr( "href" ) )
				// 				.attr( "href", $( '.home-v2-toggle' ).data( "open-state-href" ) );
				// 		} );
				// 	}
					
				// 	else {
				// 		$( ".header-top-banner-wrap a[data-open-state-href]" ).each( function() {
				// 			$( '.home-v2-toggle' )
				// 				.attr( "href", $( '.home-v2-toggle' ).data( "orig-state-href" ) )
				// 				.removeAttr( "data-orig-state-href" );
				// 		} );
				// 	}
				// } );
			}
		},

		'page_testimonials': {
			init: function(){

				$(".testimonial-video-card a[data-uk-toggle]").on("click", function(evt){

					if($(this).data("embed-url") !== ""){

						var embedUrl = "";

						if($(this).data("embed-url").indexOf("www.youtube.com/embed/") >= 0){

							embedUrl = $(this).data("embed-url");

						}else{

							var videoUrlParts = $(this).data("embed-url").split(/\/|\?v=/);

							var videoId = "";

							if(videoUrlParts.length > 1){
								videoId = videoUrlParts.pop();
							}

							if(videoId !== ""){
								embedUrl = "https://www.youtube.com/embed/" + videoId;
							}

						}

						$($(this).attr("href")).find("iframe").attr("src", embedUrl);

					}

				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
